<template>
  <div class="airportItem"
    :class="{hide: !itemVisible}">
    <div class="checkbox chkDisplay">
      <input type="checkbox" :id="`display_${item.airportName}`" v-model="itemVisible" :checked="itemVisible" />
      <label :for="`display_${item.airportName}`"><span class="blind">{{locale.state_public}}</span></label>
    </div>
    <p class="airport">{{item.airportName}}</p>
    <div class="info">
      <p class="name">{{item.Name}}</p>
      <p class="city colorGrey">{{`${item.City}, ${item.Country}`}}</p>
      <p class="long">{{distance}}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'locale',
    'item'
  ],
  computed: {
    visible () {
      return this.$store.state.flightinfo.setting.visible
    },
    distance () {
      return `${this.locale.localinfo_fromhotel} ${this.item.distanceKM.toFixed()}km`
    },
    itemVisible: {
      get () {
        const name = this.item.airportName
        const isVisible = this.visible.includes(name)
        return isVisible
      },
      set (visible) {
        const data = {
          airportName: this.item.airportName,
          visible: visible
        }
        this.$store.commit('flightinfo/setVisible', data)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.airportItem {
  display: flex;
  align-items: center;
  position: relative;
  margin-bottom: 15px;
  border: 1px solid $color-lgrey2;
  border-radius: 4px;
  box-shadow: 0 0 5px rgba(0,0,0,0.1);
  &.hasPhotos {
    padding-left: 150px;
  }
}
.airport {
  width: 140px;
  padding: 30px 0;
  text-align: center;
  font-size: 2.4em;
  font-weight: 700;
  border-right: 1px solid $color-lgrey2;
}
.info {
  padding: 0 30px;
}
.name {
  font-size: 1.1em;
  font-weight: 700;
}
.long {
  color: $color-lgrey;
}
.walking {
  margin-left: 0.5em;
}
.hide {
  opacity: 0.5;
}
.chkDisplay {
  position: absolute;
  top: 5px;
  left: 5px;
  z-index: 2;
}
.option {
  margin-top: auto;
  padding: 15px;
  border-top: 1px solid $color-lgrey2;
}
.optionItem {
  display: flex;
  align-items: center;
  & + .optionItem {
    margin-top: 5px;
  }
  .optionLabel {
    flex: 1;
  }
  .optionValue {
    flex: 1.2;
  }
  .input {
    min-width: 0;
    min-height: 0;
    padding: 0.2em 0.8em;
    border: 1px solid $color-lgrey2;
  }
}
</style>
